import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActiveStatusWithReasonDto } from 'src/api/models';

@Component({
  selector: 'app-desactivate-infos-popup',
  templateUrl: './desactivate-infos-popup.component.html',
  styleUrls: ['./desactivate-infos-popup.component.css']
})
export class DesactivateInfosPopupComponent implements OnInit {
  @Input() desactivateInfos: ActiveStatusWithReasonDto;
  @Input() public visible: boolean;
  @Output() onClosed = new EventEmitter();
  
  constructor() { }

  ngOnInit() {
  }

  onHidden() {
    this.visible = false;
    this.onClosed.emit();
  }

}
